import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [createPersistedState()],

  state: {
    isAppLoad: true,
    isFooterMenu: false,
    isLanguage: false,
    ispositionbottom: false,
    isFGF: false,
    localecode: 'en',
    savedRegisterConnections: {},
  },
  mutations: {
    Loading(state, value) {
      state.isAppLoad = value
    },
    FooterMenu(state, value) {
      state.isFooterMenu = value
    },
    Language(state, value) {
      state.isLanguage = value
    },
    LanguagePosition(state, value) {
      state.ispositionbottom = value
    },
    setLocalecode(state, value) {
      state.localecode = value
    },
    savedRegisterConnections(state, connections) {
      state.savedRegisterConnections = connections
    },
    showFGF(state, value) {
      state.isFGF = value
    },
  },
  actions: {},
})
